import React from "react";
import { CalendarOutlined, UserOutlined } from "@ant-design/icons";
import * as S from "./style";
import { TicketListItem, TicketActionsProps } from "./types";
import { TicketActions } from "./TicketActions";

interface TicketTableProps extends Omit<TicketActionsProps, 'ticket'> {
  ticketsList: TicketListItem[];
}

export const TicketTable: React.FC<TicketTableProps> = ({ 
  ticketsList, 
  loadingAction, 
  isBusy, 
  onContinue, 
  onFinishAndCreate, 
  onFinishOnly 
}) => {
  return (
    <S.TableContainer>
      <S.TableHeader>
        <S.Col flex={2}>PROTOCOLO DE ATENDIMENTO</S.Col>
        <S.Col flex={1.5}>DATA DA ABERTURA</S.Col>
        <S.Col flex={1.5}>USUÁRIO ATUAL</S.Col>
        <S.Col flex={2} center>AÇÕES</S.Col>
      </S.TableHeader>

      <S.TableBody>
        {ticketsList.map((ticket) => (
          <S.TableRow key={ticket.id}>
            <S.Col flex={2}>
              <S.ProtocolNumber>{ticket.protocol}</S.ProtocolNumber>
              <S.ProtocolDesc>{ticket.status}</S.ProtocolDesc>
            </S.Col>

            <S.Col flex={1.5}>
              <S.TextData>
                <CalendarOutlined /> {ticket.formattedDate || ticket.created_at}
              </S.TextData>
            </S.Col>

            <S.Col flex={1.5}>
              <S.TextData>
                <UserOutlined /> {ticket.atendenteAtual || ticket.criadoPor}
              </S.TextData>
            </S.Col>

            <S.Col flex={2}>
              <TicketActions
                ticket={ticket}
                loadingAction={loadingAction}
                isBusy={isBusy}
                onContinue={onContinue}
                onFinishAndCreate={onFinishAndCreate}
                onFinishOnly={onFinishOnly}
              />
            </S.Col>
          </S.TableRow>
        ))}
      </S.TableBody>
    </S.TableContainer>
  );
};